export var OnlineSample;
(function (OnlineSample) {
    OnlineSample.ActionTakenEnum = {
        Accepted: 'Accepted',
        Rejected: 'Rejected',
        Enforced: 'Enforced',
        Unavailable: 'Unavailable',
        NA: 'NA'
    };
})(OnlineSample || (OnlineSample = {}));
